import { useContext, useState } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import MyExpenses from '../components/expenseReports/MyExpenses';
import ReviewPanel from '../components/expenseReports/ReviewPanel';

export const APPROVER_PERMISSION = 'expense_reports_admin';

/**
 * Expense Reports: every signed-in employee submits and tracks their own
 * expenses; holders of expense_reports_admin also get the Review & pay tab.
 */
const ExpenseReportsPage = () => {
  const auth = useContext(AuthContext);
  const isApprover = Boolean(auth?.hasPermission?.(APPROVER_PERMISSION));
  const [tab, setTab] = useState(isApprover ? 'review' : 'mine');
  const activeTab = isApprover ? tab : 'mine';

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="h3 mb-0">
          <i className="bi bi-receipt me-2"></i>
          Expense Reports
        </h1>
      </div>

      {isApprover && (
        <ul className="nav nav-tabs mb-4">
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === 'review' ? 'active' : ''}`}
              onClick={() => setTab('review')}
            >
              <i className="bi bi-list-check me-2"></i>
              Review &amp; pay
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === 'mine' ? 'active' : ''}`}
              onClick={() => setTab('mine')}
            >
              <i className="bi bi-person me-2"></i>
              My expenses
            </button>
          </li>
        </ul>
      )}

      {activeTab === 'review' ? <ReviewPanel /> : <MyExpenses />}
    </div>
  );
};

export default ExpenseReportsPage;
